<template>
  <div class="licenses--sites-item tile">
    <h3 class="content__heading">{{ website }}</h3>
    <div class="flex__between licenses--select">
      <label for="state-select" class="mr-10">Select a state:</label>
      <select id="state-select" v-model="state">
        <option value></option>
        <option
          v-for="license in getWebsiteLicenses"
          :key="license._id"
          :value="license.state"
        >{{ license.state }}</option>
      </select>
    </div>
    <div class="licenses--content-empty licenses--content" v-if="getWebsiteLicenses.length === 0">
      <p class="text__center text__bold">No licenses for this website</p>
    </div>
    <div v-else class="licenses--content-full licenses--content">
      <p
        v-if="filteredLicenses.length === 0"
        class="text__center text__bold"
      >Select a license to view</p>
      <StateLicense
        v-else
        v-for="license in filteredLicenses"
        :key="license._id"
        :license="license"
      />
    </div>
    <a class="license--add" @click="setActiveWebsite" href="#license-create">
      <font-awesome-icon icon="plus-circle" size="3x" class="icon" />
    </a>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import StateLicense from "./StateLicense";
export default {
  props: ["website"],
  components: {
    StateLicense
  },
  data() {
    return {
      state: ""
    };
  },
  computed: {
    ...mapGetters(["getLicenses"]),
    getWebsiteLicenses() {
      return this.getLicenses.filter(license => {
        return license.website === this.website;
      });
    },
    filteredLicenses() {
      return this.getWebsiteLicenses.filter(license => {
        return license.state === this.state;
      });
    }
  },
  methods: {
    setActiveWebsite() {
      this.$store.dispatch("startSetActiveWebsite", this.website);
    }
  }
};
</script>

<style scoped lang="scss">
.icon {
  color: $green;
  @include pos-abs(
    $top: null,
    $left: null,
    $bottom: -10px,
    $right: -10px,
    $z: 4
  );
}
</style>